import { render } from "./LeagueIcon.vue?vue&type=template&id=783e9668&scoped=true"
import script from "./LeagueIcon.vue?vue&type=script&lang=js"
export * from "./LeagueIcon.vue?vue&type=script&lang=js"

import "./LeagueIcon.vue?vue&type=style&index=0&id=783e9668&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-783e9668"]])

export default __exports__